export enum PromptTypeDTO {
  Operation = 'Operation',
  ImageFile = 'ImageFile',
  RasterFontFile = 'RasterFontFile',
  Slide = 'Slide',
  SlideElement = 'SlideElement',
  TerminalStatus = 'TerminalStatus',
  Response = 'Response',
  Timetable1 = 'Timetable1',
  BacklightSettings = 'BacklightSettings',
  AudioVolumeSettings = 'AudioVolumeSettings',
  RegularFile = 'RegularFile',
  RowEraser = 'RowEraser',
}
